var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-wrapper"},[_c('input',{style:(_vm.cssInputProps),attrs:{"disabled":_vm.readOnly,"placeholder":_vm.placeholder,"type":_vm.type},domProps:{"value":_vm.value},on:{"input":_vm.onInput}})])}
var staticRenderFns = []

export { render, staticRenderFns }